import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PlanningRouteOverviewSettingsModel} from "../../models/planning-route-overview-settings.model";
import {LocationType} from "../../../commons/types/location.type";

export class PlanningRouteOverviewTableRowCtrl implements IController {

  activity: any;
  job: any;
  depot: any;
  index: any;
  isSelected: boolean;
  columns: PlanningRouteOverviewSettingsModel;
  onSelect: Function;

  public planningRouteOverviewTableCtrl: IController;
  // public locationTypes: typeof LocationType = LocationType;
  // public contact: any;
  public barcodesList: any;
  public packages: any;
  public labels: string[] = [];

  // For Groups (Bundles).
  public jobs?: any[];
  public fulfillmentIds?: string[];


  /* @ngInject */
  constructor(private $filter) {
  }

  $onInit() {
    if (this.activity) {

      if (this.activity.type === 'GROUP') {
        this.jobs = this.activity.jobIds.map((id) => {
          return this.planningRouteOverviewTableCtrl.jobsMap[id]
        })
        this.fulfillmentIds = _.compact(this.jobs.map((j) => {return j.fulfillmentId}));
      }

      this._setPackages(this.activity);

      this.barcodesList = this.packages.filter((p) => !!p.barcode).map((p) => p.barcode);
      this.job?.packages?.forEach(p => {
        if(p.labels?.length) {

          this.labels = this.labels.concat(p.labels);
        }
      })
      this.activity.totals = this.getActivityPackageTotals(this.packages);
      this.activity.accountSyncIds = _.map(this.activity);
    }
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.activity && !onChangesObj.activity.isFirstChange()) {
      this.$onInit();
    }
  }

  // private setContact(activity) {
  //   const isBundle = _.isEqual(activity.type, 'GROUP');
  //   const isStartOrEnd = _.isEqual(activity.type, 'START') || _.isEqual(activity.type, 'END');
  //
  //   const jobsIds = isBundle ? activity.jobIds : (isStartOrEnd ? [] : [activity.jobId]);
  //
  //   let contact;
  //
  //   _.forEach(jobsIds, (id) => {
  //     const jobRef = this.planningRouteOverviewTableCtrl.jobsMap[id];
  //     if (!jobRef) {
  //       this.contact = jobRef.contact
  //       return;
  //     }
  //   })
  // }

  private _setPackages(activity){
    const isBundle = _.isEqual(activity.type, 'GROUP');
    const isStartOrEnd = _.isEqual(activity.type, 'START') || _.isEqual(activity.type, 'END');

    let packages = [];
    const jobsIds = isBundle ? activity.jobIds : (isStartOrEnd ? [] : [activity.jobId]);

    _.forEach(jobsIds, (id) => {
      const jobRef = this.planningRouteOverviewTableCtrl.jobsMap[id];
      if (!jobRef) {
        return;
      }
      packages = packages.concat(_.get(jobRef, 'packages', []));
    })
    this.packages = packages;
  }

  private getActivityPackageTotals(packages) {



    return {
      packages: packages,
      packagesCount: this.$filter('servicePackagesCount')(packages),
      volume: this.$filter('jobPackagesVolume')(packages),
      weight: this.$filter('jobPackagesWeight')(packages)
    }
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteOverviewTableRow', {
    require: {
      planningRouteOverviewTableCtrl: '^planningRouteOverviewTable'
    },
    bindings: {
      activity: '<',
      job: '<',
      depot: '<?',
      index: '<',
      isSelected: '<?',
      columns: '<?',
      onToggleSelect: '&'
    },
    template: require('./planning-route-overview-table-row.html').default,
    controller: PlanningRouteOverviewTableRowCtrl
  });
